import FileUploader from './FileUploader'
import Table from './Table'

export {
  FileUploader,
  Table
}



// WEBPACK FOOTER //
// ./src/components/Modals/StorageUploadModal/components/index.js